import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

export const form: ThemeUICSSObject = {
  alignItems: 'end',
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  height: '80vh',
};
